import React, { Component } from "react";

import QAErrorRow from "./QAErrorRow";


import { withStyles } from '@material-ui/core/styles';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});

class QAErrorList extends Component {
	constructor(props) {
        super(props);
		
		this.showAllErrors = this.showAllErrors.bind(this);
		this.renderButons  = this.renderButons.bind(this);
    }

	renderButons(){
		if(typeof this.props.acceptAction !== 'undefined'){
			return  <Grid container direction="row" justifyContent="space-around" alignItems="flex-start">
						<Grid item xs={2}><Button onClick={this.props.acceptAction} variant="contained" color="primary">ACCEPT QA</Button></Grid>
						<Grid item xs={2}><Button onClick={this.props.declineAction} variant="contained" color="secondary">REFUSE AND EDIT QA</Button></Grid>
					</Grid>
		}else{
			return "";
		}
	}
	
	showAllErrors(){
		if(typeof this.props.dropdown !== 'undefined'){
			this.props.dropdown();
		}
	}
	
	render() {
		let rows = [];
		if(this.props.errors){
			this.props.errors.forEach(element => {if(element.severity>0){ rows.push(<QAErrorRow
																						id={element.id}
																						severity={element.severity}
																						position={element.tuNumber}
																						category={element.categoryDescription}
																						description={element.description}
																						enabled={element.enabled}
																						goToSegment={typeof this.props.goToSegment !== 'undefined' ? this.props.goToSegment : null}
																						dropdown={typeof this.props.acceptAction === 'undefined'}
																						switchAction={this.props.switchAction}
																					/>);}});
		}
		return (
		<div>
		  <Table stickyHeader className="lst">
		    <TableHead  onClick={this.showAllErrors}>
		      <TableRow>
				{typeof this.props.acceptAction === 'undefined' && <TableCell><ArrowDropDownIcon /></TableCell>}
				{typeof this.props.acceptAction !== 'undefined' && <TableCell>Enabled</TableCell>}
				<TableCell>Segment</TableCell>
				<TableCell>Severity</TableCell>
				<TableCell>Category</TableCell>
				<TableCell>Description</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		  </Table>
		  {this.renderButons()}
		</div>
		);
  }
};

export default withStyles(styles)(QAErrorList);